import { v4 as uuidv4 } from 'uuid';
import {
  customersAuthorizationApi,
  ECustomerAuthorizationEndpoints
} from '../api';
import { EGerdauService } from '../EGerdauService';
import { getValueCookie } from './utils';
import { CookiesKey } from './enum';
import type { IUser } from '../../store/ducks/user/types';

const INTERNAL_DOMAINS = ['@gerdau.com', '@ex.gerdau.com'];

export const trackPurchaseAttempt = async (
  user: Pick<IUser, 'email' | 'isManager' | 'salesRep'>,
  soldTo: string,
  shipTo?: string
): Promise<void> => {
  const isInternalDomain = INTERNAL_DOMAINS.some((d) => user.email.endsWith(d));
  if (user.isManager || user.salesRep || isInternalDomain) return;

  const userSessionId =
    getValueCookie(CookiesKey.CORRELATION_ID) ??
    EGerdauService.setCorrelationId(uuidv4());
  const headers = new EGerdauService().getHeaders();
  await customersAuthorizationApi.post(
    ECustomerAuthorizationEndpoints.PURCHASE_ATTEMPT,
    { user_session_id: userSessionId, username: user.email },
    { headers, params: { soldTo, shipTo: shipTo || soldTo } }
  );
};
